const BASE_API_URL = 'https://hotel.upload.lk';

export default BASE_API_URL;